import i18n from "@/i18n";
import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { api } from "@/lib/api";

// Block B — audited deficit explanation. Explanation only: it never
// establishes legal responsibility or creates a wage deduction.
const CATEGORIES = {
    get UNCLASSIFIED() { return i18n.t("wf.DeficitExplanationForm.CATEGORIES.UNCLASSIFIED", "Unclassified"); },
    EMPLOYEE_RELATED: "Employee-related",
    EMPLOYER_RELATED: "Employer-related",
};

export const DeficitExplanationForm = ({ cycleId, restaurantId, onSaved }) => {
    const [category, setCategory] = useState("UNCLASSIFIED");
    const [text, setText] = useState("");
    const [busy, setBusy] = useState(false);
    const submit = async () => {
        setBusy(true);
        try {
            const { data } = await api.post(
                `/workforce/averaging/cycles/${cycleId}/settlement/deficit-explanation`,
                { restaurant_id: restaurantId, category, text });
            toast.success(i18n.t("wf.deficitExplanationForm.explanationRecorded", "Explanation recorded"));
            setText("");
            onSaved(data);
        } catch (e) {
            const code = e?.response?.data?.detail?.code;
            toast.error(code || "Could not record the explanation");
        } finally {
            setBusy(false);
        }
    };
    return (
        <div className="space-y-2" data-testid={`deficit-explanation-form-${cycleId}`}>
            <p className="text-xs text-slate-600">
                {i18n.t("wf.deficitExplanationForm.explanationOnlyItDoesNotDecide", "Explanation only — it does not decide legal responsibility or create a wage deduction.")}
            </p>
            <Select value={category} onValueChange={setCategory}>
                <SelectTrigger className="w-56 bg-white" data-testid={`deficit-explanation-category-${cycleId}`}>
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {Object.entries(CATEGORIES).map(([k, v]) => (
                        <SelectItem key={k} value={k} data-testid={`deficit-category-option-${k}`}>{v}</SelectItem>
                    ))}
                </SelectContent>
            </Select>
            <Textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={1000}
                placeholder={i18n.t("wf.deficitExplanationForm.explainTheDeficit", "Explain the deficit")} className="bg-white"
                data-testid={`deficit-explanation-text-${cycleId}`} />
            <Button size="sm" disabled={busy || text.trim().length < 3} onClick={submit}
                data-testid={`deficit-explanation-submit-${cycleId}`}>
                {i18n.t("wf.deficitExplanationForm.recordExplanation", "Record explanation")}
            </Button>
        </div>
    );
};

export const categoryLabel = (c) => CATEGORIES[c] || c;

export default DeficitExplanationForm;
